import { h, FunctionComponent } from 'preact';
import Button from '../../../components/button/button';
import { first as _first, get as _get } from 'lodash';
import Translate from '../../../components/translate/translate';
import { TaskNote } from '@bringg/types';

interface Props {
	onRateUs: () => void;
	customerNotes: TaskNote[];
}

const ProofOfDelivery: FunctionComponent<Props> = ({ onRateUs, customerNotes }) => {
	const proofOfDeliveryImage = _get(_first(customerNotes), 'url');
	return (
		<div className="proof-of-delivery" data-testid="proof-of-delivery">
			<div className="info">
				<span className="message">
					<Translate text="RATING.PROOF_OF_DELIVERY_MESSAGE" />
				</span>
				<div className="proof-of-delivery-frame" id="proof-of-delivery-frame">
					<div
						className="proof-of-delivery-image"
						style={{ backgroundImage: `url(${proofOfDeliveryImage})` }}
					/>
				</div>
			</div>

			<Button className="filled-button rate-us" onClick={onRateUs}>
				<Translate text="SCHEDULE.RATE_US" />
			</Button>
		</div>
	);
};

export default ProofOfDelivery;
